var _Mask, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path, G, Mask, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

function SvgClimbing(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 23,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M13.575 22.539c-.328.122-.692.19-1.063.19-.4 0-.796-.046-1.16-.154L7.226 32.09c-.376.874-1.415 1.171-2.318.66-.902-.51-1.327-1.627-.939-2.504l5.056-11.635h6.446v-1.088L18.73 16c.857-.42 1.963.297 2.192 1.202l1.599 6.439a1.7 1.7 0 11-3.299.82l-1.017-4.1-4.63 2.177z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M3.513 13.239a1.455 1.455 0 001.776.562l3.735-1.468v5.197h6.447v-6.018l5.776-9.278a1.46 1.46 0 00-.454-2.009c-.675-.426-1.57-.229-1.949.434L13.94 8.544l-2.958.007c-.19 0-.379.03-.568.107l-5.109 2.01-2.633-4.004A1.45 1.45 0 00.669 6.23a1.465 1.465 0 00-.44 2.017l3.284 4.992z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M11.808 8.018c1.418 0 2.57-1.15 2.57-2.571a2.577 2.577 0 00-2.57-2.579 2.578 2.578 0 00-2.572 2.579 2.571 2.571 0 002.572 2.571z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(G, {
    filter: "url(#climbing_svg__filter0_d_3566_9916)"
  }, _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "climbing_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M15.695 32.545V22.046l-1.046.46v10.039h1.046z"
  }))), /*#__PURE__*/React.createElement(Path, {
    d: "M15.695 32.545V22.046l-1.046.46v10.039h1.046z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M15.695 32.545v1.111h1.112v-1.111h-1.112zm0-10.499h1.112v-1.703l-1.56.686.448 1.017zm-1.046.46L14.2 21.49l-.664.292v.725h1.112zm0 10.039h-1.112v1.111h1.112v-1.111zm2.158 0V22.046h-2.223v10.499h2.223zm-1.56-11.516l-1.046.46.896 2.035 1.046-.46-.896-2.035zm-1.71 1.478v10.038h2.223V22.507h-2.223zm1.112 11.15h1.046v-2.224H14.65v2.223z",
    fill: props.fill,
    mask: "url(#climbing_svg__a)"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}

export default SvgClimbing;